<template>
	<details ref="details" class="spofaq-searchapp__result-detail" :key="post.id">
		<summary class="spofaq-searchapp__result-summary" v-on:click="toggle" v-html="post.title.rendered">
		</summary>
		<div
			class="spofaq-searchapp__result-content"
			v-html="post.content.rendered"
		></div>
	</details>
</template>

<script>
export default {
	name: "Post",
	props: {
		open: {
			type: Number,
			default: -1,
		},
		post: {
			type: Object,
			required: true,
		},
	},
	watch: {
		open: function (newVal) {
			this.updateVal(newVal);
		},
	},
	mounted: function () {
		this.updateVal(this.open);
	},
	methods: {
		toggle() {
			this.$emit("toggled", this.post.id);
		},
		updateVal(val) {
			if (val == this.post.id) {
				// https://stackoverflow.com/questions/53707415/how-to-show-a-element-immediately-such-as-a-loading-indicator-with-vue-nextti
				window.setTimeout(() => {
					if (this.$refs.details) {
						this.$refs.details.setAttribute("open", "");
					}
				}, 25);
			} else {
				window.setTimeout(() => {
					if (this.$refs.details) {
						this.$refs.details.removeAttribute("open");
					}
				}, 25);
			}
		},
	},
};
</script>

<style scoped></style>
